import {Input} from '@yandex-delivery/blocks'
import {useI18n} from '@yandex-delivery/core/i18n'
import {Controller, useFormContext} from '@yandex-delivery/form'
import React from 'react'

import type {NameProps} from './NameInput.types'

export function NameInput({name, 'data-testid': dataTestId}: NameProps): React.ReactElement {
  const {control} = useFormContext()
  const t = useI18n()

  return (
    <Controller
      control={control}
      defaultValue=""
      name={name}
      render={({field, fieldState}) => {
        return (
          <div ref={field.ref}>
            <Input
              data-testid={dataTestId}
              error={fieldState.invalid}
              helperText={fieldState.error?.message}
              label={t('cargo.create.contact.name', 'Имя')}
              name={name}
              onBlur={field.onBlur}
              onChange={field.onChange}
              size="l"
              value={field.value}
              variant="line"
            />
          </div>
        )
      }}
    />
  )
}
